<h1 class="text-truncate content-title">{{ betaProgram?.title || "Loading..." }}</h1>
<ng-container *ngIf="betaProgram">
  <span class="t-16 bold" [innerHTML]="betaProgram.description"></span>
  <myp-inline-loader [loading]="loading" height="400px" spinnerName="browseExchange"></myp-inline-loader>
  <ng-container *ngIf="snapshot">
    <div class="d-flex align-items-center m-t-50">
      <img [src]="snapshot.product.imageUrl" style="width: 100px" class="m-r-10" />
      <h2 class="brandfont-black">{{ snapshot.product.title }}</h2>
    </div>
  </ng-container>

  <div class="m-b-50" *ngIf="snapshot && !productService.isGettingProducts && !productService.productsByProductID[this.betaProgram.product_id] && !redeemingProduct">
    First you must register a copy of {{ snapshot.product.title }} to your account.
    <br />
    <button class="btn btn-primary m-t-20" (click)="claimBetaProduct()">Register {{ snapshot.product.title }}</button>
  </div>

  <div class="m-b-50" *ngIf="redeemingProduct">
    <fa-icon icon="spinner" spin="true"></fa-icon>
    Registering {{ snapshot.product.title }}...
  </div>

  <div class="m-b-50" *ngIf="snapshot && !productService.isGettingProducts && productService.productsByProductID[this.betaProgram.product_id]">
    <h4 class="section-header m-t-50">Installers and Downloads</h4>
    <div *ngIf="snapshot">
      <myp-installer-buttons [isSideBar]="false" [beta]="true" [downloads]="snapshot.downloads" [product]="snapshot.product"></myp-installer-buttons>
    </div>
  </div>
</ng-container>
